"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../helpers");
exports.useWillSelect = function () {
    var willSelectState = helpers_1.useStateValue({});
    var setWillSelect = function (_a, startPosition) {
        var rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
        willSelectState.updateValue(function () {
            var _a, _b;
            var value = {};
            if (startPosition) {
                var rowEnd = rowIndex > startPosition.rowIndex ? rowIndex : startPosition.rowIndex;
                var rowStart = rowIndex < startPosition.rowIndex ? rowIndex : startPosition.rowIndex;
                for (rowStart; rowStart <= rowEnd; rowStart++) {
                    var columnEnd = columnIndex > startPosition.columnIndex
                        ? columnIndex
                        : startPosition.columnIndex;
                    var columnStart = columnIndex < startPosition.columnIndex
                        ? columnIndex
                        : startPosition.columnIndex;
                    for (columnStart; columnStart <= columnEnd; columnStart++) {
                        if (!value[rowStart]) {
                            value[rowStart] = {};
                        }
                        value[rowStart][columnStart] = true;
                    }
                }
                return value;
            }
            return _a = {},
                _a[rowIndex] = (_b = {},
                    _b[columnIndex] = true,
                    _b),
                _a;
        });
    };
    var removeWillSelect = function (_a) {
        var rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
        willSelectState.updateValue(function () {
            var _a, _b;
            return _a = {},
                _a[rowIndex] = (_b = {},
                    _b[columnIndex] = false,
                    _b),
                _a;
        });
    };
    var removeAllWillSelect = function () {
        willSelectState.updateValue(function () {
            return {};
        });
    };
    var isSomeInRowWillSelect = function (rowIndex) {
        var row = willSelectState.getValue()[rowIndex] || {};
        return Object.entries(row).some(function (item) { return item[1]; });
    };
    var isSomeInColumnWillSelect = function (columnIndex) {
        return Object.entries(willSelectState.getValue()).some(function (item) {
            return item[1][columnIndex];
        });
    };
    var isWillSelected = function (_a) {
        var rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
        var _b, _c;
        return !!((_c = (_b = willSelectState.getValue()) === null || _b === void 0 ? void 0 : _b[rowIndex]) === null || _c === void 0 ? void 0 : _c[columnIndex]);
    };
    var getAllWillSelected = function () {
        var result = [];
        var rows = willSelectState.getValue();
        Object.entries(rows).forEach(function (item) {
            var rowIndex = Number(item[0]);
            return Object.entries(item[1]).forEach(function (colItem) {
                if (colItem[1]) {
                    result.push({ rowIndex: rowIndex, columnIndex: Number(colItem[0]) });
                }
            });
        });
        return result;
    };
    return {
        setWillSelect: setWillSelect,
        removeWillSelect: removeWillSelect,
        removeAllWillSelect: removeAllWillSelect,
        isSomeInRowWillSelect: isSomeInRowWillSelect,
        isSomeInColumnWillSelect: isSomeInColumnWillSelect,
        isWillSelected: isWillSelected,
        getAllWillSelected: getAllWillSelected
    };
};
//# sourceMappingURL=useWillSelect.js.map